
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MbscModule, MbscPopup } from '@mobiscroll/angular';
import { FilterResourcesService } from '../services/filter-resources.service';
import { getPopupButtons, popupOptionsResourceFilter } from '../interfaces/popup-buttons/filter/popup-options';
import { ScreenService } from '../services/shared/screen.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-filter-resources-popup',
  imports: [MbscModule],
  templateUrl: './filter-resources-popup.component.html',
  styleUrl: './filter-resources-popup.component.scss'
})
export class FilterResourcesPopupComponent {

  constructor(public filterResourcesService: FilterResourcesService, public screenService: ScreenService, public router: Router){}

  @Input() userResourceId!: number;
  @ViewChild('filterButton') anchorElm!: ElementRef;
  @ViewChild('popup', { static: false })

  popup!: MbscPopup;
  popupAnchor!: HTMLButtonElement;
  filters: { [key: string]: boolean } = {};
  tempFilters: { [key: string]: boolean } = {};
  searchTimeout: ReturnType<typeof setTimeout> | undefined;
  filterAll: boolean = true;

  public popupOptionsResourceFilter = popupOptionsResourceFilter;
  
 popupButtons = getPopupButtons({
    resetFilters: () => this.resetFilters(),
    applyAllFilters: () => this.applyAllFilters(),
    applyFilters: (source: string) => this.applyFilters(source),
    getFilters: () => this.filters,
    setTempFilters: (filters: any) => this.tempFilters = { ...filters },
  });

  @ViewChild(FilterResourcesPopupComponent) filterResourcesPopup!: FilterResourcesPopupComponent;


  //openFilters(popupAnchor: any) {
  //  console.log(this.router.url);
  //  this.popupAnchor = popupAnchor;
//
  //  //this.tempFilters = {};
  //  console.log('TEAM-FILTER',this.filterResourcesService.teamFilters);
  //  [...this.filterResourcesService.otherFilters,
  //   ...this.filterResourcesService.teamFilters,
  //   ...this.filterResourcesService.interpreterFilters].forEach(filter => {
  //    this.tempFilters[filter.id] = true; // oder deinen gespeicherten Wert
  //  });
//
  //  if (this.screenService.smallScreen) {
  //    this.tempFilters[this.userId.toString()] = true;
//
  //    this.filterResourcesService.myFilters.forEach(filter => {
  //      filter.disabled = (filter.id === this.userId.toString());
  //    });
//
  //    this.filterResourcesService.filterFlatResources(this.tempFilters, this.filterResourcesService.searchQuery);
  //  }
//
  //  if(this.screenService.smallScreen){
  //    this.filterResourcesService.filterFlatResources(this.tempFilters, this.filterResourcesService.searchQuery);
  //  }else{
  //    this.filterResourcesService.filterResources(this.tempFilters, this.filterResourcesService.searchQuery);
  //  }
//
  //  this.popup.open();
  //  const savedCollapsed = localStorage.getItem('collapsedTeams');
  //  if (savedCollapsed) {
  //    const savedTeams = JSON.parse(savedCollapsed);
  //    this.showOnlyTeam(savedTeams);
  //  }
  //  console.log(this.tempFilters)
  //}


  openFilters(popupAnchor: any) {
    this.popupAnchor = popupAnchor;
    
    // gespeicherte Filter laden
    let savedFilters;
    if(this.screenService.smallScreen){
      savedFilters = localStorage.getItem('mobileCalendarFilters');
    }else{
      savedFilters = localStorage.getItem('calendarFilters');
    }
    

    if (savedFilters) {
      this.tempFilters = JSON.parse(savedFilters);
    } else {
      // Fallback: alle aktivieren
      this.tempFilters = {};

      [
        ...this.filterResourcesService.otherFilters,
        ...this.filterResourcesService.teamFilters,
        ...this.filterResourcesService.interpreterFilters
      ].forEach(filter => {
        this.tempFilters[filter.id] = true;
      });
    }

    console.log('Geladene Filter:', this.tempFilters);

    if (this.screenService.smallScreen) {

      if(!savedFilters){
        // Alle Filter deaktivieren
        Object.keys(this.tempFilters).forEach(id => {
          this.tempFilters[id] = false;
        });

        // Nur die eigene Ressource aktivieren
        this.tempFilters[this.userResourceId.toString()] = true;
      }

      this.filterResourcesService.filterFlatResources(
        this.tempFilters,
        this.filterResourcesService.searchQuery
      );

    }else{
      this.filterResourcesService.filterResources(
        this.tempFilters,
        this.filterResourcesService.searchQuery
      );
    }

    this.popup.open();

    //const savedCollapsed = localStorage.getItem('collapsedTeams');
    //
    //if (savedCollapsed) {
    //  const savedTeams = JSON.parse(savedCollapsed);
    //  this.showOnlyTeam(savedTeams);
    //}
  }


  //Show Collapsed Teams
  showOnlyTeam(collapsedTeams: string[]) {
    if (!Array.isArray(collapsedTeams)) {
      console.error("collapsedTeams ist kein Array! Wert:", collapsedTeams);
      return;
    }

    this.filterResourcesService.mySortedResources = this.filterResourcesService.mySortedResources.map(group => {
      if (collapsedTeams.includes(group.id)) {
        return { ...group, collapsed: true };
      }

      return { ...group, collapsed: false };
    });

    this.filterResourcesService.filteredResources = this.filterResourcesService.mySortedResources;
  }

  @Output() filtersApplied = new EventEmitter<void>();
  
  applyFilters(option: string) {
    this.filters = { ...this.tempFilters };
    if(this.screenService.smallScreen){
      this.filterResourcesService.filterFlatResources(this.tempFilters, this.filterResourcesService.searchQuery);
      localStorage.setItem('mobileCalendarFilters', JSON.stringify(this.tempFilters));
    }else{
      this.filterResourcesService.filterResources(this.tempFilters, this.filterResourcesService.searchQuery);
      localStorage.setItem('calendarFilters', JSON.stringify(this.tempFilters));
    }
    // Parent benachrichtigen
    this.filtersApplied.emit();
    if(option === 'button'){
      this.popup.close();
    }
  }


  applyAllFilters() {
    const allowed = [];
    this.filterAll = !this.filterAll;
    const filter = this.filterAll;
    this.tempFilters = Object.fromEntries(
      Object.keys(this.tempFilters).map(key => [
        key,
        filter  // wenn "alle an" => true, sonst nur die erlaubten true
      ])
    );
    this.filters = { ...this.tempFilters };
    this.filterResourcesService.filterResources(this.filters, this.filterResourcesService.searchQuery);
    [
      ...this.filterResourcesService.otherFilters,
      ...this.filterResourcesService.teamFilters,
      ...this.filterResourcesService.interpreterFilters
    ].forEach(filterObj => {
      filterObj.value = this.tempFilters[filterObj.id] ?? false;
    });
  }


  resetFilters() {
    this.filterResourcesService.searchQuery = '';
  
    let updatedFilters: { [key: string]: boolean } = {};
  
    if (this.screenService.smallScreen) {
    
      // Mobile: Nur eigene Resource aktivieren
      updatedFilters = {
        [this.userResourceId.toString()]: true
      };
    
      this.filterResourcesService.filterFlatResources(updatedFilters, '');
    
      localStorage.setItem(
        'mobileCalendarFilters',
        JSON.stringify(updatedFilters)
      );
    
    } else {
    
      // Desktop: Alle Filter aktivieren
      const allFilters = [
        ...this.filterResourcesService.otherFilters,
        ...this.filterResourcesService.teamFilters,
        ...this.filterResourcesService.interpreterFilters
      ];
    
      updatedFilters = allFilters.reduce<{ [key: string]: boolean }>((map, filter) => {
        map[filter.id] = true;
        return map;
      }, {});
    
      this.filterResourcesService.filterResources(updatedFilters, '');
    
      localStorage.setItem(
        'calendarFilters',
        JSON.stringify(updatedFilters)
      );
    }
  
    this.filters = { ...updatedFilters };
    this.tempFilters = { ...updatedFilters };
  
    this.updateDisabledCheckboxes();
  
    this.filtersApplied.emit();
  
    console.log('RESET FILTER:', updatedFilters);
  }
  

  handleSearch() {
    clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => {
      this.filterResourcesService.filterResources(this.filters, this.filterResourcesService.searchQuery);
    }, 300);
    const savedCollapsed = localStorage.getItem('collapsedTeams');
    if (savedCollapsed) {
      const savedTeams = JSON.parse(savedCollapsed);
      this.showOnlyTeam(savedTeams);
    }
  }


  handleCheckboxChange(key: string) {
    // Nur mobile Ansicht: myFilters verwenden
    if (this.screenService.smallScreen) {
      const ownId = this.userResourceId.toString();
      if (key === ownId) return;

      this.tempFilters[key] = !this.tempFilters[key];
      this.tempFilters = { ...this.tempFilters };

      // Zähle aktive (true) Einträge, aber ohne eigene ID
      const activeCount = Object.entries(this.tempFilters)
        .filter(([id, value]) => id !== ownId && value)
        .length;

      if (activeCount > 3) {
        this.tempFilters[key] = false; // zurücknehmen
        return;
      }

      // Eigene ID immer aktiv halten
      this.tempFilters[ownId] = true;
      localStorage.setItem('mobileCalendarFilters', JSON.stringify(this.tempFilters))
      this.applyFilters('checkbox');
      this.updateDisabledCheckboxes();
    } else {
      // Desktop / Teamansicht
      this.tempFilters[key] = !this.tempFilters[key];
      this.tempFilters = { ...this.tempFilters };
      localStorage.setItem('calendarFilters', JSON.stringify(this.tempFilters))
      this.applyFilters('checkbox');
    }
  }


  updateDisabledCheckboxes() {
    const ownId = this.userResourceId.toString();
  
    const activeCount = Object.entries(this.tempFilters)
      .filter(([id, value]) => id !== ownId && value)
      .length;
  
    this.filterResourcesService.myFilters.forEach(filter => {
      const isOwn = filter.id === ownId;
      filter.disabled = isOwn || (activeCount >= 3 && !this.tempFilters[filter.id]);
    });
  }
}
